import { QGetLimitsHistory } from "./QGetLimitsHistory";
import { QGetPlayer } from "./QGetPlayer";
import { QChangePassword } from "./QChangePassword";
import { QVerifyToken } from "./QVerifyToken";
export const QueryBuilder = {
    getLimitsHistory: QGetLimitsHistory,
    getPlayer: QGetPlayer,
    changePassword: QChangePassword,
    verifyToken: QVerifyToken
};
//# sourceMappingURL=index.js.map